import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import type { DeviceSigner } from '../../../services/deviceSigner';

/** @notInstrumented */
export const getDeviceSigner = async (
  client: DynamicClient
): Promise<DeviceSigner> => {
  const { deviceSigner, keychain } = getCore(client);

  /**
   * If the device signer is available, it should handle the device signing.
   * This is used for mobile devices with secure enclave.
   */
  if (deviceSigner) {
    return deviceSigner;
  }

  const keyName = 'device';

  const existingPublicKey = await keychain.getPublicKey(keyName);

  if (!existingPublicKey) {
    await keychain.generateKey(keyName);
  }

  return {
    getPublicKey: () => keychain.getPublicKey(keyName) as Promise<string>,
    sign: (payload: string) => keychain.sign(keyName, payload),
  };
};
